var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEDB01",
    d: "M12.682 14.284H6.429V5.143h6.253a3.886 3.886 0 0 1 3.882 3.887v1.367a3.887 3.887 0 0 1-3.882 3.887"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0B1AC",
    d: "M14.289 18.857h-7.86v-4.573a4.567 4.567 0 0 1 4.568-4.568h3.292a4.57 4.57 0 1 1 0 9.141"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D6D3C",
    d: "M16.564 10.32v.077a3.887 3.887 0 0 1-3.887 3.887H6.43a4.57 4.57 0 0 1 4.568-4.568h3.292c.831 0 1.607.223 2.275.604"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoba);
export default __webpack_public_path__ + "static/media/boba.e933c4e2cb67dc0e28f6c6e6cefaffcc.svg";
export { ForwardRef as ReactComponent };